module.exports = __webpack_public_path__ + "img/dropdown.27bb0c8f.svg";